import { createSlice } from '@reduxjs/toolkit'
import { fetchCards } from '.'
import { filtersMinMax, filterStoredMinMax, selectNormalizedFilters } from '../selectors'


const initialState = {
   filters: {},
   isFiltering: {},
   products: {},
   sortBy: { value: 'rating', label: 'популярные' },
   queryString: {},
   minmax: {}
}

const filtersSlice = createSlice({
   name: 'filters',
   initialState,
   reducers: {
      startFiltering(state, action) {
         const { url, newMinMax } = action.payload

         state.isFiltering[url] = true
         if (newMinMax) state.minmax[url] = newMinMax
      },
      startSorting(state, action) {
         state.sortBy = action.payload
      },
      endFiltering(state, action) {
         const { url, sortedProducts, queryString } = action.payload

         state.isFiltering[url] = false
         state.products[url] = sortedProducts
         state.queryString[url] = queryString
      }
   },
   extraReducers: builder => {
      builder.addCase(fetchCards.fulfilled, (state, action) => {
         const url = action.meta.arg
         state.filters[url] = action.payload.filters
      })
   }
})

export const filters = filtersSlice.reducer
export const { startFiltering, endFiltering, startSorting } = filtersSlice.actions

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const sortCheap = (arr, prd) => arr.sort((a, b) => prd[a]['p'] - prd[b]['p'])
const sortExpensive = (arr, prd) => arr.sort((a, b) => prd[b]['p'] - prd[a]['p'])
const sortRating = (arr, prd) => arr.sort((a, b) => prd[b]['r'] - prd[a]['r'])

const sortProductsByValue = (sortBy, arr, prd) => {
   switch (sortBy.value) {
      case 'cheap':
         return sortCheap(arr, prd)
      case 'expensive':
         return sortExpensive(arr, prd)
      case 'rating':
         return sortRating(arr, prd)
      default:
         throw new Error('неизвестный парамаетр сортировки')
   }
}

//////////////////////////////////////////////////////////////////////////
export const sortProducts = (sortBy, url) => async (dispatch, getState) => {
   const state = getState()
   const arr = [...state.filters.products[url]]
   const prd = state.cards.products[url]
   const queryString = state.filters.queryString[url]

   dispatch(startSorting(sortBy))

   dispatch(startFiltering({ url }))

   const sortedProducts = await sortProductsByValue(sortBy, arr, prd)

   dispatch(endFiltering({ sortedProducts, url, queryString }))
}

//////////////////////////////////////////////////////////////////////////
const filteredProducts = (productsbyCategory, selected, normalizedFilters) => {
   // массив массивов для сортировки:
   const sortArr = Object.keys(selected).reduce((acc, key) => {
      const arr = selected[key].map(item => normalizedFilters[key][item])
      const obj = Object.assign({}, ...arr)
      acc.push(obj)
      return acc
   }, [])

   // сортировка:
   return sortArr.reduce((acc, obj) => {
      return acc.filter(item => item in obj)
   }, productsbyCategory)
}

//////////////////////////////////////////////////////////////////////////
export const filterProducts = (url, search, minmax = null) => (dispatch, getState) => {
   const state = getState()
   const filters = state.filters.filters[url]
   const products = Object.keys(state.cards.products[url])
   const normalizedFilters = selectNormalizedFilters(state, url)

   const searchParams = search ? search : new URLSearchParams(state.filters.queryString[url])

   const getSelected = (filters, searchParams) => {
      return filters.reduce((acc, { searchGroup, products }) => {
         const group = searchParams.get(searchGroup)
         if (group) {
            const groupItems = group.split('_').filter(item => item in products)
            if (groupItems.length > 0) acc[searchGroup] = groupItems
         }
         return acc
      }, {})
   }

   const selected = getSelected(filters, searchParams)

   // if range triggered, minmax goes from range(else from stored) || stored minmax || option 3 - only initialization
   const newMinMax = minmax ? minmax : filterStoredMinMax(url)(state) ? filterStoredMinMax(url)(state) : filtersMinMax(state, url)
   dispatch(startFiltering({ url, newMinMax }))

   Promise.resolve(products).then(products => {
      // checkbox:
      const isCheckboxSelected = Object.keys(selected).length
      const filteredByCheckbox = isCheckboxSelected ? filteredProducts(products, selected, normalizedFilters) : products

      // range-slider:
      const [MIN, MAX] = newMinMax
      const filteredByPrice = filteredByCheckbox.reduce((result, id) => {
         const price = state.cards.products[url][id].p
         if (price >= MIN && price <= MAX) result.push(id)
         return result
      }, [])

      // select:
      const sortBy = state.filters.sortBy
      const prd = state.cards.products[url]
      const sortedProducts = sortProductsByValue(sortBy, filteredByPrice, prd)

      // attn: searchParams stringified on purpose, so in products it can be checked if its empty string(do not change)
      dispatch(endFiltering({ sortedProducts, url, queryString: searchParams.toString() }))
   })
}